require('./sendExtractsViaMailStep2.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @core
const { formatText } = require('core/i18n').i18n;

// @components
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @helpers
const { toFirstUppercase } = require('utilities/stringHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

class SendExtractsViaMailStep1 extends React.Component {
    render() {
        const { match: { params: { extractType } }, immDocument, immProfile } = this.props;

        const month = toFirstUppercase(moment(immDocument.get('fechaAlta')).format('MMMM YYYY'));
        const documentType = immDocument.get('nombreGrupoComunicacion');
        const clientEmail = PersonalDataHelper.getEmail(immProfile);

        return (
            <article className="send-extracts-via-mail-step-2">
                <header className="wizard_header">
                    <h1 className="wizard-step--vertical__title">
                        {formatText('sendExtractsViaMail-step2Title')}
                    </h1>
                </header>
                <h2 className="send-extracts-via-mail-step-2__subtitle">
                    {formatText('sendExtractsViaMail-step2Subtitle')}
                </h2>
                <div className="send-extracts-via-mail-step-2__confirmation-script">
                    <ConfirmationScript operative={formatText(`operatives-sendExtractsViaMail${extractType}`)} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
                </div>
                <section className="send-extracts-via-mail-step-2__data">
                    <OKInformativeList columns={3}>
                        <OKInformativeListItem
                            title="sendExtractsViaMail-monthLabel"
                            bodyText={month}
                        />
                        <OKInformativeListItem
                            title="sendExtractsViaMail-extractTypeLabel"
                            bodyText={documentType}
                        />
                        <OKInformativeListItem
                            title="sendExtractsViaMail-step2MailTextLabel"
                            bodyText={clientEmail}
                        />
                    </OKInformativeList>
                </section>

                <div className="send-extracts-via-mail-step-2__confirmation-script">
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </div>
            </article>
        );
    }
}

SendExtractsViaMailStep1.propTypes = {
    match: PropTypes.string.isRequired,
    immDocument: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
};

module.exports = SendExtractsViaMailStep1;
